import { render } from "./CodeHome.vue?vue&type=template&id=a5e1cdda"
import script from "./CodeHome.vue?vue&type=script&lang=js"
export * from "./CodeHome.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__